/**
 * Code for MSH Document Listing
 */
import $ from "jquery";

var contactListingContainer = $("#msh-contact-listing");

if (contactListingContainer && contactListingContainer.length > 0) {
    $(function () {
        $('.resources').hide();
        // On page load get the contacts info thorugh and ajax call b/c it comes from an api
        getContacts();
    });
}

function getContacts() {
    // Init helper vars
    var apiUrl = $("#contact-listing-apiurl").val();

    $.ajax({
        url: apiUrl,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            // Add return items
            buildContacts(data.contacts);
            if (data.warranty != null) {
                buildWarranty(data.warranty);
            }
        },
        error: function (request, error) {
            console.log("Request: " + JSON.stringify(error));
        }
    });
}

function buildContacts(arr) {
    // Build new items
    for (var i = 0; i < arr.length; i++) {
        var template = '<div class="cell medium-4">';

        template += ('<p class="lead">' + arr[i].firstName + ' ' + arr[i].lastName + '</p>');

        if (arr[i].role != undefined && arr[i].role != null && arr[i].role != '') {
            template += ('<p>' + arr[i].role + '</p>');
        }

        if (arr[i].phone != undefined && arr[i].phone != null && arr[i].phone != '') {
            template += ('<p class="show-for-medium"><span>P:</span> ' + formatPhone(arr[i].phone) + '</p><p class="show-for-small-only"><span>P:</span> <a href="tel:' + arr[i].phone + '">' + formatPhone(arr[i].phone) + '</a></p>');
        }

        if (arr[i].email != undefined && arr[i].email != null && arr[i].email != '') {
            template += ('<p><span>E:</span> <a href="mailto:' + arr[i].email + '">' + arr[i].email + '</a></p>');
        }
        template += '</div>';
        $("#contacts-wrapper").append(template);
    }

    // If there is no account, return this message: For assistance with your home, please contact (866) 535-9959.
    if (arr.length == 0) {

        var noContent = '<div class="cell text-center no-listings">';

        noContent += '<!--Show for medium only-->';
        noContent += '<p class="show-for-medium">For assistance with your home, please email our <a href="mailto:warranty@sheahomes.com">customer service team</a>.</p>';

        noContent += '<!--Show for small only-->';
        noContent += '<p class="show-for-small-only">For assistance with your home, please email our <a href="mailto:warranty@sheahomes.com">customer service team</a>.</p>';

        noContent += '</div>'

        $("#contacts-wrapper").append(noContent);
    }
}

function buildWarranty(obj) {
    if (obj != null && obj.hasOwnProperty('fileName') && obj['fileName']) {
        // Build new item
        $("#warranty-name").text(obj.fileName);
        if (obj.fileLastModifiedLabel == '' || obj.fileLastModifiedLabel == null || obj.fileLastModifiedLabel == undefined || obj.fileLastModifiedLabel == 'null') {
            $("#warranty-date").hide();
        }
        else {
            $("#warranty-date").show().text("Date Added: " + obj.fileLastModifiedLabel);
        }
        $("#warranty-link-1").attr("href", getFileURL(obj.fileDownloadUrl, obj.fileName, obj.fileType));
        $("#warranty-link-2").attr("href", getFileURL(obj.fileDownloadUrl, obj.fileName, obj.fileType));
        $('.resources').show();
    }
}

function getFileURL(url, fileName, fileExtension) {
    var apiUrl = $("#contact-listing-loadurl").val()
    var urlParam = "url=" + url + "&filename=" + fileName + "&extension=" + fileExtension;
    return encodeURI(apiUrl + "/?" + urlParam);
}

function formatPhone(phone) {
    var cleaned = ('' + phone).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        var intlCode = (match[1] ? '+1 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
}